export default "__VITE_ASSET__CoouoxM1__"